import { styled } from '@linaria/react';
import { useSpring, animated } from 'react-spring';

import Box from './Box';
import Code from './Code';
import Wrapper from './Wrapper';

function ScaleDemo({ singleAxis, withText, x, y }) {
  const styles = useSpring({
    transform: singleAxis ? `scale(${x})` : `scale(${x}, ${y})`,
  });

  return (
    <Wrapper>
      <Box style={styles}>{withText && 'Hello World'}</Box>
      <Code>transform: scale({singleAxis ? x : `${x}, ${y}`});</Code>
    </Wrapper>
  );
}

export default ScaleDemo;
